import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocationOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"location_on"}/>
}
